var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dialogs.length),expression:"dialogs.length"}],staticClass:"vDialogContainer"},_vm._l((_vm.dialogs),function(dlg,index){return _c('vDialog',{key:index,attrs:{"setting":dlg,"dialogIndex":index,"dialogKey":_vm.keyPrefix + _vm.keyNum},on:{"close":_vm.closeDialog}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.1@vue-loader/lib/template-compiler?{"id":"data-v-68a3047a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=template&index=0!./src/vDialogContainer.vue
// module id = 15
// module chunks = 0